import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  NumberInput,
  NumberInputField,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  Input
} from '@chakra-ui/react'
import { ChangeEvent, FC } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useParametrizationCurveWeight from '@hook/parametrization/use-curve-weight'

const ParametrizationCurveWeightCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    paramsEdit,
    selected,
    handleUpdateEditParams,
    createData,
    updateDataCurve
  } = useParametrizationCurveWeight()
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    handleUpdateEditParams({
      name: 'curva',
      value: value
    })
  }

  return (
    <>
      {selected !== 0 ? (
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          leftIcon={<FiEdit2 />}
          colorScheme="green"
          variant="outline"
          onClick={onOpen}
        >
          Editar
        </Button>
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          onClick={onOpen}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            bg="white"
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selected !== 0 ? 'Editar Curva Peso' : 'Criar Curva Peso'}
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <FormControl isRequired>
              <FormLabel>(*) Curva</FormLabel>
              <Input
                borderBottomColor="black"
                value={paramsEdit.curva}
                onChange={handleInputChange}
              ></Input>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Peso Loja</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.pesoLoja}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'pesoLoja',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Peso Empresa</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.pesoEmpresa}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'pesoEmpresa',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Peso Volume</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.pesoVolume}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'pesoVolume',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Peso Curva</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.pesoCurva}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'pesoCurva',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Corte Inicial</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.corteInicial}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'corteInicial',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Corte Final</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.corteFinal}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'corteFinal',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
          </ModalBody>
          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                if (selected !== 0) {
                  updateDataCurve()
                  onClose()
                } else {
                  createData()
                  onClose()
                }
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationCurveWeightCreate
